"use client";

import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import Link from "next/link";

const SocialIcons = () => {
  const iconSize = 20; // px
  const iconClass = "hover:text-secondary transition-colors duration-300";

  return (
    <div className="flex flex-col items-center text-white gap-2">
      <Link href="https://www.facebook.com" target="_blank" aria-label="Facebook">
        <Facebook size={iconSize} className={iconClass} />
      </Link>
      <Link href="https://www.instagram.com" target="_blank" aria-label="Instagram">
        <Instagram size={iconSize} className={iconClass} />
      </Link>
      <Link href="https://www.linkedin.com" target="_blank" aria-label="LinkedIn">
        <Linkedin size={iconSize} className={iconClass} />
      </Link>
      <Link href="https://www.youtube.com" target="_blank" aria-label="YouTube">
        <Youtube size={iconSize} className={iconClass} />
      </Link>
    </div>
  );
};

export default SocialIcons;
